import { useLocale } from '../context/LocaleContext'
import { ExperienceSection } from './ExperienceSection'
import { SectionHeading } from './SectionHeading'

export function ExperienceList() {
  const { content } = useLocale()
  const { ui, experiences } = content
  return (
    <section className="experience-section section-shell" id="experience">
      <SectionHeading eyebrow={ui.workEyebrow} title={ui.workTitle} intro={ui.workIntro} />
      <div className="experience-list">{experiences.map((experience) => <ExperienceSection key={experience.id} experience={experience} ui={ui} />)}</div>
    </section>
  )
}
